import React from 'react'

/**
 * Convenience higher order component to forward all properties to the moduleProps property of the provided component.
 * This can be useful in conjunction with the LoadableComponent and LoadableEsmComponent to forward all props
 * to their appropriate moduleProps property.
 */
export const withModuleProps = Component => props => {
    const { children, ...rest } = props
    return <Component moduleProps={{ ...rest }}>{children}</Component>
}
